// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__twgvt","col":"CardReaderDesc_col__1Inhs","label":"CardReaderDesc_label__r9o4z"};